import React, { useEffect, useState } from 'react';
import '../css/CustomModal.css';
import '../css/StatisticsModal.css'; // Import the new statistics-specific CSS

function CustomModal({ isOpen, onClose, children, title, isStatistics = false }) {
  const [showMobileView, setShowMobileView] = useState(window.innerWidth <= 768);
  
  // Close modal with escape key and handle body scroll locking
  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (isOpen && e.key === 'Escape') {
        onClose();
      }
    };
    
    const handleResize = () => {
      setShowMobileView(window.innerWidth <= 768);
    };

    document.addEventListener('keydown', handleEscapeKey);
    window.addEventListener('resize', handleResize);
    
    // Lock body scroll when modal is open
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
      window.removeEventListener('resize', handleResize);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  // Handle auto-detection of tables inside the modal content
  const wrapTablesForMobile = (content) => {
    if (!showMobileView) return content;
    
    // This is a simple implementation - for a complete solution,
    // you might need to use React.Children to traverse and clone elements
    return React.Children.map(content, child => {
      if (!child || typeof child !== 'object') return child;
      
      if (child.type === 'table' || (child.props && child.props.className?.includes('table'))) {
        return <div className="mobile-table-wrapper">{child}</div>;
      }
      
      // If the child has children, recursively process them
      if (child.props && child.props.children) {
        return React.cloneElement(child, {
          ...child.props,
          children: wrapTablesForMobile(child.props.children)
        });
      }
      
      return child;
    });
  };

  if (!isOpen) return null;

  // Use different CSS classes for statistics modal
  if (isStatistics) {
    return (
      <div className="statistics-modal-overlay" onClick={onClose}>
        <div 
          className={`statistics-modal-content ${showMobileView ? 'mobile-view' : ''}`} 
          onClick={(e) => e.stopPropagation()}
        >
          <div className="statistics-modal-header">
            {title && <h2 className="statistics-modal-title">{title}</h2>}
            <button className="statistics-modal-close" onClick={onClose} aria-label="Close modal">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="statistics-modal-body">
            {showMobileView ? wrapTablesForMobile(children) : children}
          </div>
        </div>
      </div>
    );
  }

  // Default modal for non-statistics content
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal-content ${showMobileView ? 'mobile-view' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          {title && <h2 className="modal-title">{title}</h2>}
          <button className="modal-close" onClick={onClose} aria-label="Close modal">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          {showMobileView ? wrapTablesForMobile(children) : children}
        </div>
      </div>
    </div>
  );
}

export default CustomModal;